import { __assign, __awaiter, __generator } from "tslib";
import { createClient } from '@wix/sdk/client';
import * as cart from '@wix/auto_sdk_ecom_cart-v-2';
import { getSDKAuthAndHost } from '../getSDKAuthAndHost';
import { SPECS } from '../../constants';
var CartService = /** @class */ (function () {
    function CartService(_a) {
        var context = _a.context;
        this.siteStore = context.siteStore;
        this.currentCartService = context.currentCartService;
        this.cartApi = createClient(__assign(__assign({}, getSDKAuthAndHost(context.siteStore)), { modules: {
                cart: {
                    getCart: cart.getCart,
                    calculateCart: cart.calculateCart,
                    updateCart: cart.updateCart,
                    removeGiftCard: cart.removeGiftCard,
                    addGiftCard: cart.addGiftCard,
                    addCoupon: cart.addCoupon,
                    removeCoupon: cart.removeCoupon,
                    removeLineItems: cart.removeLineItems,
                    setDeliveryMethod: cart.setDeliveryMethod,
                    refreshCart: cart.refreshCart,
                    placeOrder: cart.placeOrder,
                },
            } })).cart;
    }
    CartService.prototype.shouldUseCurrentCartService = function (cartId) {
        return (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents) &&
            this.currentCartService.getCurrentCartIdFromCache() === cartId);
    };
    CartService.prototype.getCart = function (cartId) {
        if (this.shouldUseCurrentCartService(cartId)) {
            return this.currentCartService.getCurrentCart();
        }
        return this.cartApi.getCart(cartId);
    };
    CartService.prototype.calculateCart = function (cartId) {
        if (this.shouldUseCurrentCartService(cartId)) {
            return this.currentCartService.calculateCurrentCart();
        }
        return this.cartApi.calculateCart(cartId);
    };
    CartService.prototype.updateCart = function (cartId, updateCart) {
        if (this.shouldUseCurrentCartService(cartId)) {
            return this.currentCartService.updateCurrentCart(updateCart);
        }
        return this.cartApi.updateCart(cartId, updateCart);
    };
    CartService.prototype.removeGiftCard = function (cartId, giftCardId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.removeGiftCardFromCurrentCart({ giftCardId: giftCardId })];
                        }
                        return [4 /*yield*/, this.cartApi.removeGiftCard(cartId, giftCardId)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.addGiftCard = function (cartId, giftCardInput) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.addGiftCardToCurrentCart({ giftCardInput: giftCardInput })];
                        }
                        return [4 /*yield*/, this.cartApi.addGiftCard(cartId, giftCardInput)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.removeCoupon = function (cartId, couponId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.removeCouponFromCurrentCart({ couponId: couponId })];
                        }
                        return [4 /*yield*/, this.cartApi.removeCoupon(cartId, couponId)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.addCoupon = function (cartId, couponInput) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.addCouponToCurrentCart({ coupon: couponInput })];
                        }
                        return [4 /*yield*/, this.cartApi.addCoupon(cartId, couponInput)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.removeLineItems = function (cartId, lineItemIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.removeLineItemsFromCurrentCart({ lineItemIds: lineItemIds })];
                        }
                        return [4 /*yield*/, this.cartApi.removeLineItems(cartId, lineItemIds)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.setDeliveryMethod = function (cartId, deliveryMethod) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.setDeliveryMethodForCurrentCart({ deliveryMethod: deliveryMethod })];
                        }
                        return [4 /*yield*/, this.cartApi.setDeliveryMethod(cartId, deliveryMethod)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.refreshCart = function (cartId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUseCurrentCartService(cartId)) {
                            return [2 /*return*/, this.currentCartService.refreshCurrentCart()];
                        }
                        return [4 /*yield*/, this.cartApi.refreshCart(cartId)];
                    case 1: return [2 /*return*/, (_a.sent()).cart];
                }
            });
        });
    };
    CartService.prototype.placeOrder = function (cartId, placeOrderOptions) {
        return this.cartApi.placeOrder(cartId, placeOrderOptions);
    };
    return CartService;
}());
export { CartService };
//# sourceMappingURL=CartService.js.map